import { Button, InputField, ModalDetailTableCard } from '@components/common';
import { fetchTransaction } from '@shared/api';
import { CA, MONITORING, REPORTING, Transaction } from '@shared/constants';
import { initialValueFilterMonitoring } from '@shared/constants/dtos/initialValue.dtos';
import { formSearchMonitoring, optionStateDefault, transactionDate } from '@shared/constants/form/monitoring.form.constant';
import { convertDate, removeEmptyObject } from '@shared/functions';
import { IFormProps } from '@shared/interface/form.interface';
import { searchFormValidations } from '@shared/validations/search-form.validation';
import { Form, Formik } from 'formik';
import React, { Key, useEffect, useState } from 'react'
import { Card, Col, Row, Alert } from 'react-bootstrap';
import { DataTableMonitoringComponent } from '../../data-tables/data-table.component';

export const InquiryComponent = (props: any) => {
  const { typeOrg, module } = props;
  const title = (module === REPORTING ? "Reporting" : "Monitoring") + " " + (typeOrg === CA ? "CA" : "Partner");
  const [formData, setFormData] = useState<any>([]);
  const [dataList, setDataList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [paramSearch, setParamSearch] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailModal, setDetailModal] = useState<any>({});
  

  useEffect(() => {
    if (module === MONITORING) {
      setParamSearch(null);
      setFormData([...formSearchMonitoring, optionStateDefault]);
    } else {
      setParamSearch(null);
      setFormData([...formSearchMonitoring, optionStateDefault, transactionDate]);
    }
  }, [module]);

  useEffect(() => {
    setParamSearch(null);
    setPerPage(10);
    setPage(1);
    setDataList([]);
  }, [module, typeOrg]);

  useEffect(() => {
    if (paramSearch !== null) {
      fetchInquiry(paramSearch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perPage, page, paramSearch]);

  const fetchInquiry = async (temp: any) => {
    let body = {
      ...temp,
      page,
      limit: perPage,
      module: module,
      type: typeOrg,
      moduleType: Transaction?.INQUIRY,
    }
    if (module === REPORTING) body = { ...body, transaction_date: convertDate(temp.transaction_date), }
    const data = await fetchTransaction(body);
    if (data?.status === 200) {
      setDataList(data?.data);
      setIsLoading(false);
      setErrMsg("");
    } else {
      setErrMsg(data?.data?.message || "Error");
      setIsLoading(false);
    }
  }

  const handleSubmit = async (e: any) => {
    const temp = removeEmptyObject(e);
    setIsLoading(true);
    if (Object.keys(temp).length === 0) {
      setErrMsg("Please filled at least 1 field");
      setIsLoading(false);
    } else {
      setParamSearch(temp);
    }
  }

  const handlePageChange = (page: any) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage: any, page: any) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const handleShowDetail = (props: any) => {
    const { row, type } = props;
    setShowDetailModal(!showDetailModal);
    const obj = JSON.parse(row);
    setDetailModal({ ...obj, type });
  }

  return (
    <>
      <Row>
        <Col sm={12}>
          <Card>
            <Card.Header>
              <h3 style={{ color: typeOrg === CA ? "#90e8fb" : "#FF009E" }}>Inquiry {title}</h3>
            </Card.Header>
            <Card.Body>
              <Formik
                enableReinitialize={true}
                validationSchema={searchFormValidations(module)}
                initialValues={initialValueFilterMonitoring(paramSearch)}
                onSubmit={handleSubmit}
              >
                {({ errors }) => {
                  return (
                    <>
                      <Form>
                        <div className="form-row">
                          {formData.map((data: IFormProps, i: Key) => {
                            return (
                              <InputField
                                field={data}
                                errors={errors}
                                key={i}
                                width={6}
                              />
                            )
                          })}
                        </div>
                        {errMsg &&
                          <Alert className="mt-4" style={{ width: "fit-content" }} variant={"danger"} >{errMsg}</Alert>
                        }
                        <Button mode={typeOrg === CA ? "primary" : "tertiary"}>{isLoading ? "Loading..." : "Search"}</Button>
                      </Form>
                    </>
                  )
                }}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <DataTableMonitoringComponent
        title={`List Inquiry ${title}`}
        data={dataList?.data || []}
        type={typeOrg}
        loading={isLoading}
        paginationTotalRows={dataList?.total_row}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paramSearch={paramSearch}
        module={module}
        moduleType={Transaction.INQUIRY}
        handleOpenModal={(row: any, type: string) => handleShowDetail({ row, type })}
      />

      <ModalDetailTableCard
        show={showDetailModal}
        onHide={() => setShowDetailModal(!showDetailModal)}
        objDetail={detailModal}
        title={`${detailModal.type} From Biller`}
      />
    </>
  )
}